import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const FundsSummary = ({
  requiredMargin,
  availableFormatted,
  isLowMargin,
  loadingFunds,
  onRefresh,
  showMarginRefresh = false,
  isMarginStale = false,
  marginLoading = false,
  onMarginRefresh,
  marginErrorMessage,
  marginBlocked = false,
  onAvailableClick,
}) => {
  const isValidMargin = requiredMargin !== null && requiredMargin !== undefined && isFinite(requiredMargin);
  const displayMargin = isValidMargin ? requiredMargin : 0;

  const requiredColor = marginBlocked
    ? "error.main"
    : isMarginStale
      ? "warning.main"
      : (isLowMargin && displayMargin > 0)
        ? "error.main"
        : "text.primary";

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2" color="text.secondary">
          Required:
          <Typography
            component="span"
            variant="body2"
            fontWeight="medium"
            color={requiredColor}
            sx={{ ml: 0.5, opacity: isMarginStale ? 0.6 : 1 }}
          >
            ₹{displayMargin.toFixed(2)}{isMarginStale ? " *" : ""}
          </Typography>
        </Typography>
        {showMarginRefresh && (
          <Tooltip title={isMarginStale ? "Click to refresh margin (price/qty changed)" : "Refresh required margin"}>
            <span>
              <IconButton
                size="small"
                onClick={onMarginRefresh}
                disabled={marginLoading}
                sx={{ ml: 0.5, width: 22, height: 22, p: 0 }}
              >
                <RefreshIcon
                  fontSize="small"
                  sx={{ fontSize: '0.95rem', animation: marginLoading ? 'spin 1s linear infinite' : 'none' }}
                />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography 
          variant="body2" 
          color="text.secondary"
          onClick={onAvailableClick}
          sx={{ 
            cursor: onAvailableClick ? 'pointer' : 'default',
            '&:hover': onAvailableClick ? {
              opacity: 0.8,
              textDecoration: 'underline',
              textUnderlineOffset: '2px'
            } : {}
          }}
        >
          Available:
          <Typography
            component="span"
            variant="body2"
            fontWeight="bold"
            color={isLowMargin && displayMargin > 0 ? "error.main" : "success.main"}
            sx={{ ml: 0.5 }}
          >
            {availableFormatted}
          </Typography>
        </Typography>
        <Tooltip title="Refresh funds">
          <IconButton size="small" onClick={onRefresh} sx={{ ml: 0.5, width: 24, height: 24, p: 0 }} disabled={loadingFunds}>
            <RefreshIcon fontSize="small" sx={{ fontSize: '1rem', animation: loadingFunds ? 'spin 1s linear infinite' : 'none' }} />
          </IconButton>
        </Tooltip>
      </Box>

      {marginErrorMessage && (
        <Typography variant="caption" color="error.main" sx={{ display: 'block', mt: 0.5 }}>
          {marginErrorMessage}
        </Typography>
      )}
    </>
  );
};

export default FundsSummary;


